import { getSessionVariable } from '@services/storage';

import { MarketingsState, StoredMarketings } from '@hooks/use-marketings';

import { MarketingType } from '@constants/plan';
import { CUSTOM_EVENTS } from '@constants/provider';

export interface MarketingsEventState {
    portability?: boolean;
    mobile?: boolean;
    home?: boolean;
}

export function getMarketings(
    defaultMarketings: MarketingsState = {
        [MarketingType.PORTABILITY]: true,
        [MarketingType.MOBILE]: false,
        [MarketingType.HOME]: true,
    },
): MarketingsState {
    const newMarketingPlan: MarketingsState = { ...defaultMarketings };

    const storedMarketings = JSON.parse(getSessionVariable('promoConfigurator') ?? '{}') as StoredMarketings;

    if (storedMarketings) {
        if (storedMarketings.portability !== undefined) {
            newMarketingPlan[MarketingType.PORTABILITY] = storedMarketings.portability;
        }
        if (storedMarketings.mobile !== undefined) {
            newMarketingPlan[MarketingType.MOBILE] = storedMarketings.mobile;
        }
        if (storedMarketings.home !== undefined) {
            newMarketingPlan[MarketingType.HOME] = storedMarketings.home;
        }
    }

    return newMarketingPlan;
}

export function emitPriceContextChangeEvent(marketingsState: MarketingsState) {
    const lowerCasedMarketingState: MarketingsEventState = {};

    Object.keys(marketingsState).forEach((m) => {
        lowerCasedMarketingState[m.toLowerCase() as keyof MarketingsEventState] =
            marketingsState[m as keyof MarketingsState];
    });

    const discountConfiguratorEvent = new CustomEvent(CUSTOM_EVENTS.DISCOUNT_CONFIGURATOR, {
        detail: {
            ...lowerCasedMarketingState,
        },
    });
    window.dispatchEvent(discountConfiguratorEvent);
}
